<template>
	<div>
		<v-layout class="min-height-57px">
			<v-flex
				class="font-level-3-bold my-auto d-flex justify-space-between w-100 d-flex justify-space-between"
			>
				<span class="detail-svg-icon">
					<inline-svg
						fill="#006fc8"
						:src="$assetURL('media/custom-svg/receipt_long.svg')"
						height="20"
						width="20"
						class="mr-2"
					/>
					<template> Invoice</template>
				</span>

				<div class="d-flex ml-8 align-center justify-space-between">
					<AutoCompleteInput
						v-if="milestoneDropdown"
						hide-details
						:items="milestoneDropdown"
						class="w-80"
						id="milestone"
						placeholder="Milestone"
						item-text="phase"
						item-value="id"
						v-model="milestoneFilter.milestone"
					>
					</AutoCompleteInput>
					<DatePicker
						class="mx-2"
						hide-details
						:disabled="pageLoading"
						:loading="pageLoading"
						clearable
						id="date"
						v-model="milestoneFilter.date"
					>
					</DatePicker>
					<v-btn color="blue darken-4 white--text" class="mt-2" @click="initInvoice()" tile depressed>
						Search</v-btn
					>
				</div>
			</v-flex>
		</v-layout>
		<div
			v-if="!pageLoading"
			class="overflow-y taskListing"
			style="max-height: calc(100vh - 337px); min-height: 350px"
		>
			<v-simple-table class="bt-table listing-table table-head-sticky">
				<thead>
					<tr>
						<th width="10px">#</th>
						<th>Invoice No</th>
						<th>Title</th>
						<!-- <th>Proforma No</th> -->
						<th>Amount</th>
						<th width="150px">Invoice Date</th>
						<th>Status</th>
						<!-- <th>Actions</th> -->
					</tr>
				</thead>
				<tbody v-if="invoiceList.length">
					<tr
						class="cursor-pointer my-5"
						v-for="(row, index) in invoiceList"
						:key="index + 1"
						@click.prevent.stop="openInvoiceDetailDialog(index)"
					>
						<td width="10px">{{ index + 1 }}</td>
						<td width="120px">
							<Chip tooltip tooltip-text="Invoice No" :text="row.barcode" color="cyan darken-4"> </Chip>
							<div>
								<Chip
									class="mt-1"
									tooltip
									tooltip-text="Proforma No"
									:text="row.proforma_barcode"
									color="cyan darken-4"
								>
								</Chip>
							</div>
						</td>
						<td width="300px" class="text-capitalize truncate-text">
							<ShowValue :object="row" object-key="title" label="Tittle"></ShowValue>
						</td>
						<td width="250px">
							<div>
								<span class="fw-500">Raised Amount: </span>
								<ShowPrice :object="row" object-key="amount" label="amount"></ShowPrice>
							</div>
							<!-- <div>
								<span class="fw-500">Collected Amount: </span>
								<ShowPrice :object="row" object-key="collected_amount" label="Invoice amount"></ShowPrice>
							</div> -->
							<div>
								<span class="fw-500">Paid : </span>
								<ShowPrice :object="row" object-key="paid_amount" label="Paid"></ShowPrice>
							</div>
							<div>
								<span class="fw-500">Balance : </span>
								<ShowPrice :object="row" object-key="balance" label="Balance"></ShowPrice>
							</div>
						</td>
						<td>
							<!-- <ShowValue :object="row" object-key="date" label="Date"></ShowValue> -->
							<span v-if="row.date" class="fw-500 no-wrap">
								{{ formatDate(row.date) }}
							</span>
							<span v-else>
								<em class="text-muted">no date</em>
							</span>
						</td>
						<td>
							<Chip
								tooltip
								tooltip-text="Status"
								:text="row.status_value"
								:color="
									row.status_value === 'unpaid' ? 'red' : row.status_value === 'paid' ? 'green' : 'orange'
								"
							>
							</Chip>
							<!-- <v-btn @click="createInvoicePayment(row)" v-if="row.status_value !== 'paid'"
								color="green darken-4 white--text" class="ml-4" depressed small>
								Pay Now</v-btn> -->
						</td>
						<!-- <td class="simple-table-td">
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<v-btn @click.stop.prevent="openDeleteDialog(row)" color="red lighten-1" v-bind="attrs"
										class="mx-2" v-on="on" dark fab x-small>
										<v-icon small dark> mdi-trash-can-outline</v-icon>
									</v-btn>
								</template>
								<span>Delete Invoice</span>
							</v-tooltip>
						</td> -->
					</tr>
				</tbody>
				<tfoot v-else>
					<tr>
						<td colspan="11">
							<p class="m-0 row-not-found text-center py-3">
								<img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
								Uhh... There are no invoices at the moment.
							</p>
						</td>
					</tr>
				</tfoot>
			</v-simple-table>
		</div>
		<div v-else class="mx-20 my-40 text-center">
			<v-progress-linear color="orange darken-2" indeterminate height="6"></v-progress-linear>
		</div>
		<GenerateInvoice
			v-if="addDialog"
			:dialog="addDialog"
			:project="project"
			@close="addDialog = false"
			@initInvoice="initInvoice()"
		/>
		<Dialog
			v-if="isInvoiceDetailDialogOpen"
			:dialog="isInvoiceDetailDialogOpen"
			title="Asset Stocks"
			current
			v-on:close="isInvoiceDetailDialogOpen = false"
		>
			<template v-slot:title v-if="singleInvoice.title"> {{ singleInvoice.title }} </template>
			<template v-slot:body>
				<table
					v-if="singleInvoice"
					width="100%"
					class="detail-table scattered-table"
					style="font-size: 13px"
				>
					<tr>
						<th width="150px">Title</th>
						<td>
							<ShowValue :object="singleInvoice" object-key="title" label="title"> </ShowValue>
						</td>
						<th width="150px">Invoice No</th>
						<td>
							<Chip tooltip tooltip-text="Invoice No" :text="singleInvoice.barcode" color="cyan"></Chip>
						</td>
					</tr>
					<tr>
						<th width="150px">Date</th>
						<td>
							<span v-if="singleInvoice.date"> {{ formatDate(singleInvoice.date) }}</span>
							<em v-else class="text-muted">no date</em>
						</td>
						<th width="150px">Amount</th>
						<td>
							<ShowPrice :object="singleInvoice" object-key="amount" label="amount"></ShowPrice>
						</td>
					</tr>
					<tr>
						<th width="150px">Status</th>
						<td>
							<Chip
								tooltip
								tooltip-text="Status"
								:text="singleInvoice.status_value"
								:color="singleInvoice.status_value === 'paid' ? 'green' : 'red'"
							></Chip>
						</td>
					</tr>
				</table>
			</template>
			<template v-slot:action>
				<v-btn
					depressed
					tile
					:disabled="pageLoading"
					v-on:click="
						isInvoiceDetailDialogOpen = false;
						singleInvoice = null;
					"
				>
					Close
				</v-btn>
			</template>
		</Dialog>
		<ProformaDetailDialog
			:dialogOpen="proformaDetailDialogOpen"
			@close="proformaDetailDialogOpen = false"
		/>
	</div>
</template>
<script>
import ShowValue from "@/view/components/ShowValue.vue";
import ShowPrice from "@/view/components/ShowPrice.vue";
import Dialog from "@/view/components/Dialog";
import Chip from "@/view/components/Chip";
// import DeleteTemplate from "@/view/components/DeleteTemplate";
import { SET_ERROR /* SET_MESSAGE */ } from "@/core/services/store/common.module";
import AutoCompleteInput from "@/view/components/AutoCompleteInput";
import DatePicker from "@/view/components/DatePicker";
import { getInvoiceByProject /* deleteInvoice */ } from "@/core/lib/project.lib";
import GenerateInvoice from "@/view/components/GenerateInvoice.vue";
import ProformaDetailDialog from "@/view/components/ProformaDetailDialog.vue";
import ListingMixin from "@/core/mixins/listing.mixin";
export default {
	name: "Invoice_Listing",
	title: "Invoice Listing",
	mixins: [ListingMixin],
	components: {
		Dialog,
		ShowValue,
		ShowPrice,
		AutoCompleteInput,
		DatePicker,
		ProformaDetailDialog,
		Chip,
		GenerateInvoice,
	},
	data() {
		return {
			uuid: null,
			pageLoading: false,
			invoiceSN: null,
			isApproveDialogOpen: false,
			proformaDetailDialogOpen: false,
			deleteDialog: false,
			isInvoiceDetailDialogOpen: false,
			addDialog: false,
			invoice_detail: {
				name: null,
				invoice_no: null,
				attachment: null,
				date: null,
				amount: null,
			},
			singleInvoice: null,
			invoiceList: [],
			milestoneFilter: {
				milestone: null,
				date: null,
			},
		};
	},
	props: {
		project: {
			type: Object,
			default: () => {},
		},
		milestoneDropdown: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		openInvoiceDialog() {
			this.$router.push({
				name: "create-invoice",
				params: { uuid: this.project.uuid },
				query: { t: new Date().getTime() },
			});
		},

		openInvoiceDetailDialog(index) {
			this.isInvoiceDetailDialogOpen = true;
			this.singleInvoice = this.invoiceList[index];
		},
		OpenProformaDialog() {
			this.proformaDetailDialogOpen = true;
		},
		async initInvoice() {
			this.pageLoading = true;
			try {
				const data = {
					filter_milestone: this.milestoneFilter.milestone,
					filter_date: this.milestoneFilter.date,
				};
				const { invoices } = await getInvoiceByProject(this.$route.params.uuid, data);
				this.invoiceList = invoices;
			} catch (error) {
				this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
			} finally {
				this.pageLoading = false;
			}
		},
	},
	async mounted() {
		this.internal = true;
		await this.initInvoice();
		// const { milestones } = await getMilestoneByProject(this.$route.params.uuid);
		// this.milestoneList = milestones;
	},
};
</script>
